import React from "react";
import { Tag } from "antd";
import { applicationStatus } from "../constants/DataConstants";

const StatusTag = ({ statusId, statusName }) => {
    // CASE 1: Only statusId → render Tag
    if (statusId && !statusName) {
        const statusObj = applicationStatus.find((s) => s.id === statusId);
        if (!statusObj) return null;
        
        const { name, color, textColor } = statusObj;
        console.log(statusId, "statustag page")
        console.log(name, "name page")

        return (
            <Tag
                style={{
                    background: color,
                    color: textColor,
                    border: "none",
                    borderRadius: 6,
                    fontWeight: 500,
                    fontSize: 12,
                    padding: "4px 12px",
                    height: 28,
                    display: "inline-flex",
                    alignItems: "center",
                }}
            >
                {name}
            </Tag>

            //  <Tag key={color} color={color} variant={'outlined'} 
            //     style={{
            //         display: "flex",
            //         padding: "4px 12px",
            //         flexDirection: "column",
            //         alignItems: "flex-start",

            //         borderRadius: "4px",
            //         border: "1px solid rgba(59, 130, 246, 0.20)",
            //         background: "rgba(59, 130, 246, 0.10)",

            //         // color: "#3B82F6",
            //         fontSize: "12px",
            //         fontStyle: "normal",
            //         fontWeight: 400,
            //         lineHeight: "16px", /* 133.333% */

            //     }}

            //  >
            //   {name}
            // </Tag>
        );
    }

    if (!statusId && statusName) {
        const statusObj = applicationStatus && applicationStatus.find((s) => s.id === statusName);
        if (!statusObj) return null;

        return <div>{statusObj.name}</div>;
    }

    return null;
};

export default StatusTag;
